var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmarkDropdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M21.9916667,8.34166667 C21.7583333,8.10833333 21.4083333,8.10833333 21.175,8.34166667 L9.91666667,19.6 L6.24166667,15.925 C6.00833333,15.6916667 5.65833333,15.6916667 5.425,15.925 C5.19166667,16.1583333 5.19166667,16.5083333 5.425,16.7416667 L9.50833333,20.825 C9.625,20.9416667 9.8,21 9.91666667,21 C10.0333333,21 10.2083333,20.9416667 10.325,20.825 L21.9916667,9.15833333 C22.225,8.925 22.225,8.575 21.9916667,8.34166667 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-Functional-/-Tick-Dropdown",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 28,
    height: 28
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "IconTick",
    fill: "#00a3e0",
    xlinkHref: "#path-1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkDropdown);
export default __webpack_public_path__ + "static/media/checkmarkDropdown.f1e2a9854ca0097d2671c4f25096c284.svg";
export { ForwardRef as ReactComponent };